// extracted by mini-css-extract-plugin
export var attachment = "_qm-a";
export var emailContainer = "_qm-4";
export var emailContentPaddedContainer = "_qm-b";
export var emailHeader = "_qm-6";
export var emailIframe = "_qm-3";
export var emailInfoIcon = "_qm-9";
export var emailShortenedSummary = "_qm-e";
export var infoDropdown = "_qm-0";
export var infoRowBoundedContent = "_qm-d";
export var internal = "_qm-5";
export var merchant = "_qm-8";
export var messageInputContainer = "_qm-h";
export var normal = "_qm-7";
export var replyCard = "_qm-f";
export var subtleButton = "_qm-1";
export var subtleButtonIconContainer = "_qm-2";
export var toggleViewRepliesButton = "_qm-c";
export var wrappingText = "_qm-g";